import React from "react";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

const Gallery = ({ product }) => {
  return (
    <Carousel
      infiniteLoop={true}
      showStatus={false}
      showThumbs={false}
      autoPlay={false}
    >
      {product.images.map((image, i) => {
        const currentImage = getImage(image.localFile);
        return (
          <GatsbyImage
            image={currentImage}
            alt={`${product.title} image ${i}`}
          />
        );
      })}
    </Carousel>
  );
};

export default Gallery;
